import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { shouldDisplayModal } from 'src/components/hoc/asPage/modals'
import { setShouldAlert, shouldAlert } from 'src/utils/sessionStorage'
import { fetchAlerts, updateAlert } from '../../api/alert'
import { Alert } from '../../api/types/alert'

export const useAlerts = () => {
  const router = useRouter()
  const [isAlertModalOpen, setIsAlertModalOpen] = useState(false)
  const [isReportedModalOpen, setIsReportedModalOpen] = useState(false)
  const [alerts, setAlerts] = useState<Alert[]>([])

  const report = async () => {
    if (alerts.length > 0) await updateAlert(alerts[0].id)
    setIsAlertModalOpen(false)
    setIsReportedModalOpen(true)
  }

  const closeAlertModal = () => {
    setShouldAlert(false)
    setIsAlertModalOpen(false)
  }

  const closeReportedModal = () => {
    setIsReportedModalOpen(false)
  }

  useEffect(() => {
    if (shouldDisplayModal(router.pathname) && shouldAlert()) {
      fetchAlerts().then((res) => {
        if (res) setAlerts(res.alerts)
      })
    }
  }, [router.pathname])

  useEffect(() => {
    setIsAlertModalOpen(alerts.length > 0)
  }, [alerts])

  return {
    alerts,
    isAlertModalOpen,
    isReportedModalOpen,
    report,
    closeAlertModal,
    closeReportedModal,
  }
}
